export const SUPPORTED_APP_LOCALES = [
  { locale: 'en', name: 'English', nativeName: 'English', dir: 'ltr', enabled: true, seoEnabled: true, searchEnabled: true },
  { locale: 'af', name: 'Afrikaans', nativeName: 'Afrikaans', dir: 'ltr', enabled: true, seoEnabled: true, searchEnabled: true },
  { locale: 'zu', name: 'isiZulu', nativeName: 'isiZulu', dir: 'ltr', enabled: true, seoEnabled: true, searchEnabled: true },
  { locale: 'xh', name: 'isiXhosa', nativeName: 'isiXhosa', dir: 'ltr', enabled: true, seoEnabled: true, searchEnabled: true },
  { locale: 'nso', name: 'Sepedi', nativeName: 'Sepedi', dir: 'ltr', enabled: true, seoEnabled: true, searchEnabled: true },
  { locale: 'tn', name: 'Setswana', nativeName: 'Setswana', dir: 'ltr', enabled: true, seoEnabled: true, searchEnabled: true },
  { locale: 'st', name: 'Sesotho', nativeName: 'Sesotho', dir: 'ltr', enabled: true, seoEnabled: true, searchEnabled: true },
  { locale: 'ts', name: 'Xitsonga', nativeName: 'Xitsonga', dir: 'ltr', enabled: true, seoEnabled: true, searchEnabled: true },
  { locale: 'ss', name: 'Siswati', nativeName: 'Siswati', dir: 'ltr', enabled: true, seoEnabled: true, searchEnabled: true },
  { locale: 've', name: 'Tshivenda', nativeName: 'Tshivenda', dir: 'ltr', enabled: true, seoEnabled: true, searchEnabled: true },
  { locale: 'nr', name: 'isiNdebele', nativeName: 'isiNdebele', dir: 'ltr', enabled: true, seoEnabled: true, searchEnabled: true },
];

export const DEFAULT_APP_LOCALE = 'en';

const localeMap = SUPPORTED_APP_LOCALES.reduce((accumulator, entry) => {
  accumulator[entry.locale] = entry;
  return accumulator;
}, {});

export function isSupportedAppLocale(locale) {
  return Boolean(localeMap[locale]);
}

export function getLocaleConfig(locale) {
  return localeMap[locale] || localeMap[DEFAULT_APP_LOCALE];
}

export function normalizeAppLocale(locale) {
  return isSupportedAppLocale(locale) ? locale : DEFAULT_APP_LOCALE;
}

export function getLocaleName(locale) {
  return getLocaleConfig(locale).nativeName;
}

export function getLocaleSearchTerms(locale) {
  const config = getLocaleConfig(locale);
  if (config.locale === DEFAULT_APP_LOCALE) {
    return ['English', 'South Africa'];
  }

  return [config.nativeName, config.name, 'South Africa'];
}
